import { render, staticRenderFns } from "./TableCellBase.vue?vue&type=template&id=12cb9521&scoped=true&"
import script from "./TableCellBase.vue?vue&type=script&lang=ts&"
export * from "./TableCellBase.vue?vue&type=script&lang=ts&"
import style0 from "./TableCellBase.vue?vue&type=style&index=0&id=12cb9521&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cb9521",
  null
  
)

export default component.exports